module.exports = __webpack_public_path__ + "media/images/icon01-f12de914f9996870ef386f9db78be4ac.png";